import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { Button } from "antd";
import { EditOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { isUserMultiTenant, userHasPermission } from '../../../../../swzutils/UserPermissionsUtil';
import HasPermissions from "../../../../../containers/HasPermissions";
import { loggedInUserSelector } from "../../../../../store/slice/auth";
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
import { useAppSelector } from "../../../../../store";
const DivisionListTable = () => {
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const tableRef = useRef(null);
    const refresh = () => {
        tableRef.current?.fetch();
    };
    const columns = [{
            key: "tenantId",
            title: 'Profile',
            dataIndex: 'tenantName',
            sorter: false,
            width: '15%',
            condition: isUserMultiTenant(loggedInUser)
        }, {
            key: "code",
            title: 'Code',
            dataIndex: 'code',
            sorter: false,
            width: '20%',
        }, {
            dataIndex: 'name',
            title: 'Name'
        }, {
            title: 'Action',
            key: 'action',
            width: '20%',
            condition: userHasPermission(loggedInUser, ['admin:division:update']),
            render: (text, record) => (_jsx("span", { className: "actions", children: _jsx(Button, { href: `#/app/divisions/edit/${record.id}`, icon: _jsx(EditOutlined, {}), children: "Edit" }) }))
        }];
    return (_jsxs("article", { className: "article swz-fixed-table-article", children: [_jsx("h2", { className: "article-title", children: "Divisions" }), _jsxs("div", { className: "table-operations clearfix", children: [_jsx(HasPermissions, { permissions: ['admin:division:create'], children: _jsx(Button, { href: "#/app/divisions/edit/new", icon: _jsx(PlusOutlined, {}), children: "Add a new Division" }) }), _jsx(Button, { className: "pull-right", onClick: refresh, title: "Refresh", icon: _jsx(ReloadOutlined, {}) })] }), _jsx(PaginatedFilterableTable, { tableKey: 'divisionTable', ref: tableRef, dataUri: "/admin/v1/divisions", columns: columns, refreshOnSelectedTenantChanged: true })] }));
};
export default DivisionListTable;
